<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden;
  display: block !important;
}

body {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 !important;
  padding: 0 !important;
}

/* S'assurer que le footer est bien en bas */
.begin {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
}

/* Supprimer tout espace blanc potentiel */
.footer {
  margin: 0 !important;
  padding: 80px 0 0 0 !important;
  margin-bottom: 0 !important;
  margin-top: auto !important;
}

/* Dernier élément - pas d'espace après */
.footer:last-child {
  margin-bottom: 0 !important;
  padding-bottom: 40px !important;
}

/* Forcer le body à ne pas avoir de marge */
body > :last-child {
  margin-bottom: 0 !important;
}
</style>
